import React, { lazy } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { ShellRoute } from 'App/Shell'
import yn from 'yn'

import HomePage from '../HomePage'
const HomePageItau = lazy(() => import('../HomePageItau'))

const HomeRouter = ({ oidc: { user } }) => {
  let { profile } = user || {}
  profile = profile || {}
  return yn(process.env.REACT_APP_ALLOW_HOME_ITAU) && !profile.username ? (
    <ShellRoute isGuest path='/' exact component={HomePageItau} />
  ) : (
    <ShellRoute isGuest={false} path='/' exact component={HomePage} />
  )
}

const mapStateToProps = ({ oidc }) => {
  return { oidc }
}

HomeRouter.propTypes = {
  oidc: PropTypes.object
}

export default connect(mapStateToProps)(props => <HomeRouter {... props} />)



// WEBPACK FOOTER //
// ./src/HomePage/HomeRouter.js